import PropTypes from 'prop-types';

export default {
  classes: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  passengers: PropTypes.arrayOf(PropTypes.object),
  activePassenger: PropTypes.string,
  flights: PropTypes.arrayOf(PropTypes.object),
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onItemClickAction: PropTypes.any,
  onRowAction: PropTypes.any,
  selectable: PropTypes.bool,
  RowAction: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/containers/passengersList/PassengersListProps.js